<template>
  <div class="error">
    <div class="header">
      <img
        src="@/assets/images/exclamation-mark-outline.svg"
        width="60"
        height="60"
      />
      <translate tag="h2"> Error </translate>
    </div>
    <translate tag="p">
      You've found a page that doesn't exist on Pitchup.com. That can happen
      when you follow a link to something that has since been deleted. Or the
      link was incorrect to begin with.
    </translate>
    <translate tag="p">
      Sorry about that: we've logged the error for review.
    </translate>

    <br />

    <pu-link path="/">
      <translate>Go to the homepage</translate>
    </pu-link>
    <pu-link path="/campsites/">
      <translate>Search</translate>
    </pu-link>
    <translate tag="a" target="_blank" :href="contactUsLink">
      Contact us
    </translate>
  </div>
</template>

<script lang="ts">
import type { NuxtError } from 'nuxt/app'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  setup: () => {
    useHead({
      title: (useI18n().t('Page not found') + ' | Pitchup.com') as string,
    })
    return {}
  },
})
class Error404 extends Vue {
  @Prop({ type: Object, required: true }) readonly error!: NuxtError

  get contactUsLink() {
    return `https://www.pitchup.com/${
      this.$i18n.locale !== 'en-gb' ? this.$i18n.locale + '/' : ''
    }about/contact/`
  }

  mounted() {
    this.$gtm.push({ event: 'page not found' })
  }
}

export default toNative(Error404)
</script>
<style scoped>
.error {
  line-height: 1.4;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  font-size: var(--body);
  justify-content: flex-start;
  padding: 1.4em;
}

.header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0 0 1em 0;
}

.header h2 {
  margin: 0 0 0 0.5em;
  color: var(--colour-blue);
}

.error > a {
  display: block;
  margin-top: 1em;
}
</style>
